(() => {
  if (window.__cheryClickleaseInitialized) return;
  window.__cheryClickleaseInitialized = true;

  const PARTNER_URL = 'https://www.clicklease.com/partner/chery-industrial';
  const ALLOWED = /(LEK|KT|N818|T8|YON|OP|W3|BB|PP|C_|CC|WW|LS|LIDO|DEPT|AH)/i;
  const MIN_AMOUNT = 500;
  const MAX_AMOUNT = 30000;

  let renderVersion = 0;
  let refreshTimerId = null;
  let priceVisibilityObserver = null;

  function removeButtons() {
    document.querySelectorAll('.ClkButton').forEach((button) => button.remove());
  }

  function getPlacementElement() {
    return document.querySelector('.product__info-wrapper .price__container');
  }

  function getPriceElement() {
    return document.querySelector('.product__info-wrapper .price-item.price-item--sale.price-item--last');
  }

  function getPriceWrapperElement() {
    return document.querySelector('.product__info-wrapper [id^="price-"]');
  }

  function getSubtitleElement() {
    return document.querySelector('.product__subtitle');
  }

  function parseAmount(priceText) {
    const amount = Number(priceText.replace(/[^0-9.]+/g, ''));
    return Number.isFinite(amount) ? amount : null;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (character) => {
      const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      };

      return entities[character];
    });
  }

  function buttonPriceNew(payment) {
    return `<a
      href="${PARTNER_URL}"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Apply for Clicklease financing"
      style="display: block; width: 100%; max-width: 355px;"
    >
      <svg style="width: 100%;margin-top: 0px;margin-bottom: 0%;cursor: pointer;max-width: 355px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 75" width="100%" height="100%">
        <style>
          .clk__svg text {
            text-rendering: optimizeLegibility !important;
            -webkit-font-smoothing: antialiased !important;
            text-transform: none !important;
            text-decoration: none !important;
            line-height: normal !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          .clk__svg .clk__text {
            font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif !important;
            fill: #222 !important;
            font-size: 19px !important;
            font-weight: 400 !important;
            letter-spacing: 0.4px !important;
            word-spacing: 1px !important;
          }
          .clk__svg .clk__price {
            font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif !important;
            fill: #02ADEE !important;
            font-size: 19px !important;
            font-weight: 600 !important;
            letter-spacing: 0.3px !important;
          }
          .clk__svg .clk__click {
            font-family: 'Helvetica Neue', Arial, sans-serif !important;
            fill: #02ADEE !important;
            font-size: 20px !important;
            font-weight: 700 !important;
            letter-spacing: 0px !important;
          }
          .clk__svg .clk__lease {
            font-family: 'Helvetica Neue', Arial, sans-serif !important;
            fill: #555 !important;
            font-size: 20px !important;
            font-weight: 700 !important;
            letter-spacing: 0px !important;
          }
          .clk__svg .clk__btn {
            font-family: 'Helvetica Neue', Arial, sans-serif !important;
            fill: #fff !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            letter-spacing: 1.5px !important;
          }
        </style>

        <g class="clk__svg">
          <text x="10" y="55" class="clk__text">As low as</text>
          <text x="105" y="56" class="clk__price">$${escapeHtml(payment)}</text>
          <text x="150" y="55" class="clk__text">/mo with</text>

          <g transform="translate(152.5,35) scale(1.14)">
            <path d="M316.966,16.08a5.873,5.873,0,1,1,0-7.367l6.058-2.7a12.4,12.4,0,1,0,0,12.768Z" transform="translate(-228)" fill="#20b6f1"></path>
            <path d="M326.7,6.751l-6.126,2.733-6.129,2.731,6.129,2.733,6.126,2.734-1.622-5.463Z" transform="translate(-227.6 0.18)" fill="#636363"></path>
          </g>

          <text x="270" y="55" class="clk__click">click</text>
          <text x="315" y="55" class="clk__lease">lease</text>

          <rect x="370" y="37" width="110" height="27" rx="13" fill="#20b6f1"></rect>
          <text x="380" y="55" class="clk__btn">APPLY NOW</text>
        </g>
      </svg>
    </a>`;
  }

  function renderButton(payment, place, version) {
    if (version !== renderVersion || !place) return;

    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'ClkButton';
    buttonContainer.setAttribute('style', 'width: 100%; max-width: 500px');
    buttonContainer.innerHTML = buttonPriceNew(payment);
    place.after(buttonContainer);
  }

  async function refreshButton() {
    const version = ++renderVersion;

    removeButtons();

    const place = getPlacementElement();
    const price = getPriceElement();
    const priceWrapper = getPriceWrapperElement();
    const subtitle = getSubtitleElement();

    if (!place || !price || !subtitle || priceWrapper?.classList.contains('hidden')) return;

    const subtitleText = subtitle.innerText || '';
    if (!ALLOWED.test(subtitleText)) return;

    const amount = parseAmount(price.innerText || '');
    if (!amount || amount < MIN_AMOUNT || amount > MAX_AMOUNT) return;

    try {
      const response = await fetch(`https://app.clicklease.com/api/estimatedPaymentAmount/${amount}`);
      if (!response.ok || version !== renderVersion) return;

      const payload = await response.json();
      const payment = payload?.object;

      if (payment === undefined || payment === null || payment === '') return;

      renderButton(payment, place, version);
    } catch (_error) {
      // Keep the page quiet if the Clicklease endpoint is unavailable.
    }
  }

  function scheduleRefresh(delay = 0) {
    window.clearTimeout(refreshTimerId);
    refreshTimerId = window.setTimeout(() => {
      refreshButton();
    }, delay);
  }

  function observePriceVisibility() {
    const priceWrapper = getPriceWrapperElement();
    if (!priceWrapper) return;

    priceVisibilityObserver?.disconnect();
    priceVisibilityObserver = new MutationObserver(() => {
      scheduleRefresh(0);
    });
    priceVisibilityObserver.observe(priceWrapper, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        observePriceVisibility();
        scheduleRefresh(0);
      },
      { once: true }
    );
  } else {
    observePriceVisibility();
    scheduleRefresh(0);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      observePriceVisibility();
      scheduleRefresh(0);
    });
  }
})();
